// src/contexts/CoinsContext.js
import { createContext } from 'react';
export const CoinsContext = createContext({ coins: 0, setCoins: () => {} });
